import { Component, Input, OnInit, inject } from '@angular/core';
import { environment } from '../../environment';

@Component({
  selector: 'lib-environment-banner',
  templateUrl: './environment-banner.component.html',
  styleUrls: ['./environment-banner.component.scss'],
  standalone: false,
})
export class EnvironmentBannerComponent implements OnInit {
  @Input()
  environmentInfoText: string;

  cssClass: string;
  environmentName: string;

  private env = inject(environment);

  ngOnInit() {
    switch (this.env.name) {
      case 'Local': {
        this.environmentName = 'Lokal';
        this.cssClass = 'environment-local';
        break;
      }
      case 'Development': {
        this.environmentName = 'Utveckling';
        this.cssClass = 'environment-development';
        break;
      }
      case 'Systemtest': {
        this.environmentName = 'Systemtest';
        this.cssClass = 'environment-systemtest';
        break;
      }
      case 'Acceptanstest': {
        this.environmentName = 'Acceptanstest';
        this.cssClass = 'environment-acceptanstest';
        break;
      }
      case 'Utbildning': {
        this.environmentName = 'Utbildning';
        this.cssClass = 'environment-utbildning';
        break;
      }
      default: {
        break;
      }
    }
  }
}
